import { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../../../utils/api";
import { getErrorMessage } from "../../../../utils/helpers/errors";
import { getQualificationImpactUrl, getQualificationShiftActionsUrl } from "../helpers";
import { ProfileContext } from "../../context";

export const useQualificationsImpact = () => {
    const { t } = useTranslation();
    const { user } = useContext(ProfileContext);
    const { authPost } = useApi();
    const [checkingImpact, setCheckingImpact] = useState(false);

    const checkImpact = useCallback(
        async (data) => {
            setCheckingImpact(true);
            try {
                return await authPost(getQualificationImpactUrl(user?.id), { data });
            } catch (error) {
                getErrorMessage(error, t);
                throw error;
            } finally {
                setCheckingImpact(false);
            }
        },
        [authPost, user?.id, t]
    );

    const applyShiftActions = useCallback(
        async (shifts) => {
            if (!shifts?.length) return [];
            try {
                const response = await authPost(getQualificationShiftActionsUrl(user?.id), { data: { shifts } });
                return response?.results ?? [];
            } catch (error) {
                getErrorMessage(error, t);
                return [];
            }
        },
        [authPost, user?.id, t]
    );

    return { checkImpact, checkingImpact, applyShiftActions };
};
